import { Box, TextProps } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

export const ProductInformationContainer = Box.withConfig({
  accessible: true,
  focusable: true,
  paddingX: { base: '$4', md: '$0' },
  marginTop: {
    base: '$4',
    md: '$8',
  },
});

export const ProductInformationTitle = withTypography({
  variant: 'headerFour',
  fontSize: 16,
  my: '$4',
});

export const ProductInformationTextProps: TextProps = {
  fontSize: {
    base: 'xs',
    md: 'sm',
  },
};
